'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mountWithIntl = exports.shallowWithIntl = exports.shallowSnapshotWithIntl = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _enzyme = require('enzyme');

var _shallow = require('react-test-renderer/shallow');

var _shallow2 = _interopRequireDefault(_shallow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var intlProvider = new _reactIntl.IntlProvider({ locale: 'en' }, {});

var _intlProvider$getChil = intlProvider.getChildContext(),
    intl = _intlProvider$getChil.intl;

var nodeWithIntlProp = function nodeWithIntlProp(node) {

  return _react2.default.cloneElement(node, { intl: intl });
};

var shallowSnapshotWithIntl = exports.shallowSnapshotWithIntl = function shallowSnapshotWithIntl(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      context = _ref.context,
      childContextTypes = _ref.childContextTypes;

  var shallowRenderer = new _shallow2.default();
  return shallowRenderer.render(nodeWithIntlProp(node), {
    context: (0, _assign2.default)({}, context, { intl: intl }),
    childContextTypes: (0, _assign2.default)({}, { intl: _reactIntl.intlShape }, childContextTypes)
  });
};

var shallowWithIntl = exports.shallowWithIntl = function shallowWithIntl(node) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      context = _ref2.context;

  return (0, _enzyme.shallow)(nodeWithIntlProp(node), {
    context: (0, _assign2.default)({}, context, { intl: intl })
  });
};

var mountWithIntl = exports.mountWithIntl = function mountWithIntl(node) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      context = _ref3.context,
      childContextTypes = _ref3.childContextTypes;

  return (0, _enzyme.mount)(nodeWithIntlProp(node), {
    context: (0, _assign2.default)({}, context, { intl: intl }),
    childContextTypes: (0, _assign2.default)({}, { intl: _reactIntl.intlShape }, childContextTypes)
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/mocks/IntlWrapperService.js
// module id = 806
// module chunks = 10